/**
 * @generated SignedSource<<9d4d5243f80db529e5a385052a36c930>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteMeeting_viewer$data = {
  readonly user: {
    readonly isGuest: boolean;
  };
  readonly " $fragmentType": "DeleteMeeting_viewer";
};
export type DeleteMeeting_viewer$key = {
  readonly " $data"?: DeleteMeeting_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteMeeting_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteMeeting_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ed7edd396ce1016e6cec321e90f68a82";

export default node;
